import _round from 'lodash/round';

export const humanizeFileSize = (bytes: number) => {
  if (bytes === 0) return '0 Bytes';
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  return `${_round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`;
};
